// extracted by extract-css-chunks-webpack-plugin
module.exports = {"top_img":"top_img-uGqownCA","closed":"closed-3GjQeIwy","a_link":"a_link-2-rcoOCw"};